var _rect, _rect2, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNewCompletedAssessmentIconNpsDateOneCall = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#EBF6EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3289_396",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3289_396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 28V25.2C10 24.65 10.1417 24.1333 10.425 23.65C10.7083 23.1667 11.1 22.8 11.6 22.55C12.45 22.1167 13.4083 21.75 14.475 21.45C15.5417 21.15 16.7167 21 18 21C18.5 21 18.9875 21.025 19.4625 21.075C19.9375 21.125 20.4 21.2 20.85 21.3L19.1 23.05C18.9167 23.0167 18.7375 23 18.5625 23H18C16.8167 23 15.7542 23.1417 14.8125 23.425C13.8708 23.7083 13.1 24.0167 12.5 24.35C12.35 24.4333 12.2292 24.55 12.1375 24.7C12.0458 24.85 12 25.0167 12 25.2V26H18.25L20.25 28H10ZM23.55 28.4L20.1 24.95L21.5 23.55L23.55 25.6L28.6 20.55L30 21.95L23.55 28.4ZM18 20C16.9 20 15.9583 19.6083 15.175 18.825C14.3917 18.0417 14 17.1 14 16C14 14.9 14.3917 13.9583 15.175 13.175C15.9583 12.3917 16.9 12 18 12C19.1 12 20.0417 12.3917 20.825 13.175C21.6083 13.9583 22 14.9 22 16C22 17.1 21.6083 18.0417 20.825 18.825C20.0417 19.6083 19.1 20 18 20ZM18 18C18.55 18 19.0208 17.8042 19.4125 17.4125C19.8042 17.0208 20 16.55 20 16C20 15.45 19.8042 14.9792 19.4125 14.5875C19.0208 14.1958 18.55 14 18 14C17.45 14 16.9792 14.1958 16.5875 14.5875C16.1958 14.9792 16 15.45 16 16C16 16.55 16.1958 17.0208 16.5875 17.4125C16.9792 17.8042 17.45 18 18 18Z",
    fill: "#008908"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewCompletedAssessmentIconNpsDateOneCall, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/new-completed-assessment-icon-nps-date-one-call.a973052b.svg";
export { ForwardRef as ReactComponent };